import React, { useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

 
import Footer from "../components/footer";
 
import { Navbar } from "./../components/navbar/index";
import { Sidebar } from "./../components/sidebar/index";







import {
  SigninContainer,
  SigninWrapper,
  SigninP,
  SigninInput,
} from "../components/signin/SigninElements";
import { ButtonBasic } from "../components/ButtonElements";
const AdminContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f7f7f7;
`;

const UploadForm = styled.form`
  width: 100%;
  max-width: 600px;
  background-color: #fff;
  padding: 20px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const UploadInput = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
`;

const UploadTextarea = styled.textarea`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  resize: vertical;
  min-height: 100px;
`;

const UploadButton = styled.button`
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #0056b3;
  }
`;

const AdminUpload = () => {
  const [photo, setPhoto] = useState(null);
  const [bookFile, setBookFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [description, setDescription] = useState('');

  const handlePhotoChange = (e) => {
    setPhoto(e.target.files[0]);
  };

  const handleBookFileChange = (e) => {
    setBookFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    if (photo) formData.append('photo', photo);
    if (bookFile) formData.append('file', bookFile);
    formData.append('fileName', fileName);
    formData.append('description', description);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/upload`, formData, {

        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
        },
      });
      console.log("responces",response)
      toast.success(response.data.message || 'Upload successful');
      setPhoto(null);
      setBookFile(null);
      setFileName('');
      setDescription('');
    } catch (error) {
      toast.error(error.response?.data?.message || 'Error uploading the file');
    }
  };

  const userEmail = localStorage.getItem('userEmail');
  const isAdmin = [
    'alemuyohannes960@gmail.com',
    'acts23mints@gmail.com',
  ].includes(userEmail?.toLowerCase());

  if (!isAdmin) {
    return (
      <>
        <Sidebar />
        <Navbar />
        <AdminContainer style={{ height: '60vh', justifyContent: 'center' }}>
          <h2>Access Denied</h2>
          <p>Only approved administrators can upload books.</p>
        </AdminContainer>
        <Footer />
      </>
    );
  }

  return (
    <>
   <Sidebar   />
      <Navbar />
      <AdminContainer>
  <h2>Admin Upload</h2>
  <UploadForm onSubmit={handleSubmit}>
    <label>Choose Cover Photo (Image)</label>
    <UploadInput type="file" accept="image/*" onChange={handlePhotoChange} required />

    <label>Choose Book File (PDF)</label>
    <UploadInput type="file" accept="application/pdf" onChange={handleBookFileChange} required />

    <label>Book Name</label>
    <UploadInput
      type="text"
      value={fileName}
      onChange={(e) => setFileName(e.target.value)}
      placeholder="Enter the book name"
      required
    />

    <label>Description</label>
    <UploadTextarea
      value={description}
      onChange={(e) => setDescription(e.target.value)}
      placeholder="Enter a detailed description"
    />

    <UploadButton type="submit">Upload</UploadButton>
  </UploadForm>
</AdminContainer>
<Footer/> 

</>
  );
};

export default AdminUpload;
